import React, { useContext } from "react";

// Global state
import { StateContext } from "../../AppStateContext";

// Components
import CloseDrawerButton from "./CloseDrawerButton";
import OpenDrawerButton from "./OpenDrawerButton";

const ToggleSidebar = ({ classes }) => {
  // Consuming state
  const state = useContext(StateContext);

  if (state.isSidebarOpen) {
    return <CloseDrawerButton classes={classes} />;
  }
  return <OpenDrawerButton classes={classes} />;
};

export default ToggleSidebar;
